import React from 'react';
import PropTypes from 'prop-types';

import GoogleMap from 'google-map-react';
import Marker from './Marker';
import { Settings } from '../../constants/CentricConstants';

const createMapOptions = (maps) => ({
    // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
    // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition", "SymbolPath", "ZoomControlStyle",
    // "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem", "DistanceMatrixStatus",
    // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType", "GeocoderStatus", "KmlLayerStatus",
    // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference", "TravelMode", "UnitSystem"
    zoomControlOptions: {
        position: maps.ControlPosition.RIGHT_CENTER,
        style: maps.ZoomControlStyle.SMALL
    },
    mapTypeControlOptions: {
        position: maps.ControlPosition.TOP_RIGHT
    },
    mapTypeControl: true
});

const findCenter = (elements) => {
    if (!elements || elements.length === 0) { return null; }
    const lats = [];
    const lngs = [];
    elements.forEach(({lat, lng}) => {
        if ((0 === lat || Number(lat)) && (lng === 0 || Number(lng))) {
            lats.push(lat);
            lngs.push(lng);
        }
    });
    if (lats.length === 0 ) { return null; }
    if (lats.length === 1) { return {lat: lats[0], lng: lngs[0]}; }

    return {
        lat: ((Math.min(...lats) + Math.max(...lats)) / 2),
        lng: ((Math.min(...lngs) + Math.max(...lngs)) / 2),
    };
};

const SimpleMap = ({center, markers, zoom}, {settings}) => (
    <div style={{ height: '50vh', width: '100%' }}>
        <GoogleMap
            bootstrapURLKeys={{ key: settings.get(Settings.GOOGLE_API_KEY) }}
            defaultCenter={center}
            center={findCenter(markers) || undefined}
            defaultZoom={zoom}
            options={createMapOptions}
        >
            {markers.map((marker, index) => (<Marker key={index} {...marker} /> ))}
        </GoogleMap>
    </div>
);

SimpleMap.propTypes = {
    center: PropTypes.array,
    zoom: PropTypes.number,
    markers: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            lat: PropTypes.number.isRequired,
            lng: PropTypes.number.isRequired
        })
    ),
};

SimpleMap.defaultProps = ({
    center: [51.5, -0.11],
    zoom: 13,
    markers: []
});

SimpleMap.contextTypes = {
    settings: PropTypes.object.isRequired
};

export default SimpleMap;
